import React from "react";
import { ManageList } from "@/components/admin/shared";
import { useCrud } from "@/components/admin/useCrud";
import { RecipeEditor } from "@/components/RecipeEditor";
import { ExerciseEditor } from "@/components/ExerciseEditor";

const EMPTY_RECIPE = { name: "", image: "", category: "Breakfast", tags: [], intro: "", prep_time: "", cook_time: "", total_time: "", serves: "", ingredients: [], steps: [], nutrition: {}, tips: [], portion: "", suitable_for: [], active: true };
const EMPTY_EXERCISE = { name: "", image: "", category: "General Fitness", tags: [], intro: "", steps: [], duration: "", difficulty: "Beginner", suitable_for: [], precautions: [], tip: "", active: true };

const upsert = (setItems) => (saved, created) => setItems((xs) => (created ? [...xs, saved] : xs.map((x) => (x.id === saved.id ? saved : x))));

export const AdminRecipes = ({ recipes, setRecipes }) => {
  const c = useCrud("recipes", recipes, setRecipes);
  return (
    <>
      <ManageList title="Recipes" prefix="admin-recipe" items={c.filtered} query={c.query} setQuery={c.setQuery}
        onAdd={() => c.setEditing(EMPTY_RECIPE)} onEdit={c.setEditing} onDelete={c.remove} subtitle={(r) => `${r.category} · ${r.nutrition?.Calories || "—"}`} />
      {c.editing && <RecipeEditor recipe={c.editing} onClose={() => c.setEditing(null)} onSaved={upsert(setRecipes)} />}
    </>
  );
};

export const AdminExercises = ({ exercises, setExercises }) => {
  const c = useCrud("exercises", exercises, setExercises);
  return (
    <>
      <ManageList title="Exercises" prefix="admin-exercise" items={c.filtered} query={c.query} setQuery={c.setQuery}
        onAdd={() => c.setEditing(EMPTY_EXERCISE)} onEdit={c.setEditing} onDelete={c.remove} subtitle={(e) => `${e.category} · ${e.difficulty}`} />
      {c.editing && <ExerciseEditor exercise={c.editing} onClose={() => c.setEditing(null)} onSaved={upsert(setExercises)} />}
    </>
  );
};
